export const isPasscodeEmpty = (value?: string) => {
  return value?.toString().length === 0;
};

export const otpPasscodeValidate =
  (message = "error") =>
  (value?: string) => {
    const passcodeInputIsEmpty = isPasscodeEmpty(value);
    const passcodeInputContainsNonDigits = !Number(value);

    return passcodeInputContainsNonDigits || passcodeInputIsEmpty
      ? message
      : undefined;
  };
